import { useRef, useState, useEffect } from "react";

import "../styles/views/probiotique.css";

import MoreInfo from "../components/MoreInfo";
import OtherProduct from "../components/OtherProduct";
import PositifPoint from "../components/PositifPoint";

//icon liposome actif
import left_schema from "../assets/icons/liposome_left_schema.png";
import right_schema from "../assets/icons/liposome_right_schema.png";
import bottom_schema from "../assets/icons/liposome_botom_schema.png";

//icon otherProduct
import niosome from "../assets/icons/homepage_niosome.png";
import liposome from "../assets/icons/homepage_liposome.png";

import intro_img from "../assets/img/probiotique_intro.png";
import probio from "../assets/img/probio.png";
import postbio from "../assets/img/postbio.png"

import TabPostbiotique from "../components/TabPostbiotique"
import TabCatalogue from "../components/TabCatalogue";
import produits from "../assets/ProductContent/data/data_probiotique.js";

export default function Probiotique() {
    const [isMobile, setIsMobile] = useState(false);
    const probiotiqueSectionRef = useRef(null);
    const postbiotiqueSectionRef = useRef(null);

    const scrollToSection = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1050);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const probioPositifPoint = [
        [
            "Digestive support",
            "Balances intestinal flora and improves digestive comfort."
        ],
        [
            "Immune system",
            "Contributes to the body's natural defences (skin and respiratory problems...)"
        ],
        [
            "Mental well-being",
            "Positive influence on the intestine-brain axis, improved sleep and reduced stress."
        ],
        [
            "Feminine balance",
            "Prevention of gynaecological discomfort, beautiful skin, reduction in premenopausal symptoms and PMS."
        ],
        [
            "Oral health",
            "Prevention of cavities and pathogenic bacteria."
        ],
        [
            "Metabolic balance",
            "Weight control, liver protection, blood sugar regulation, cardiovascular health"
        ],
        [
            "Vitamin synthesis",
            "Helps the production of essential vitamins such as B12."
        ]
    ]

    const postbioPositifPoint = [
        [
            "Stable, targeted action",
            "Better resistance to environmental and gastric conditions."
        ],
        [
            "Microbiota support",
            "Optimises the intestinal environment by promoting a balanced microbiota."
        ],
        [
            "Proven effectiveness",
            "Contributes to benefits such as improving the immune system and protecting against oxidative stress."
        ]
    ]

    return (
        <div>
            <div className="probiotique_global-container">
                {isMobile ? (
                    <section className="probiotique_intro-container">
                        <h1 className="probiotique_intro-title">
                            <label className="bold font-42">Your supplier </label><br /><label className="orange-color">of proBIOTICS  <br />& postbiotics</label>
                        </h1>
                        <p className="probiotique_intro_legend-title">VPRO® and PROLIPO® technology</p>
                        <img className="probiotique_intro-img" src={intro_img} alt="Probiotique" />
                        <p className="probiotique_intro-subtitle">
                            Les probiotiques et les postbiotiques,<br />
                            <label className="orange-color">une alliance pour une santé optimale</label>
                        </p>
                        <p className="probiotique_intro-text">
                            LIN offers you an innovative range of microencapsulated probiotics and<br />
                            postbiotics, carefully selected to meet the needs of food supplement  <br />
                            companies. Thanks to our exclusive VPRO® and PROLIPO® <br />
                            microencapsulation technology, we can guarantee maximum efficiency and <br />
                            enhanced strain stability for your formulations.
                        </p>
                        <button
                            className="probiotique_intro_probio-btn"
                            onClick={() => scrollToSection(probiotiqueSectionRef)}
                        >
                            VPRO® Probiotics
                        </button>
                        <button
                            className="probiotique_intro_postbio-btn"
                            onClick={() => scrollToSection(postbiotiqueSectionRef)}
                        >
                            PROLIPO® Postbiotics
                        </button>
                    </section>
                ) :
                    (
                        <section className="probiotique_intro-container">
                            <div className="probiotique_intro_content-container">
                                <h1 className="probiotique_intro-title">
                                    <label className="bold font-42">Your supplier </label><br /><label className="orange-color">of proBIOTICS  <br />& postbiotics</label>
                                </h1>
                                <p className="probiotique_intro_legend-title">VPRO® and PROLIPO® technology</p>
                                <p className="probiotique_intro-subtitle">
                                    Probiotics and postbiotics, <br />
                                    <label className="orange-color">AN Alliance for optimal health</label>
                                </p>
                                <p className="probiotique_intro-text">
                                    LIN offers you an innovative range of microencapsulated probiotics and<br />
                                    postbiotics, carefully selected to meet the needs of food supplement  <br />
                                    companies. Thanks to our exclusive VPRO® and PROLIPO® <br />
                                    microencapsulation technology, we can guarantee maximum efficiency and <br />
                                    enhanced strain stability for your formulations.
                                </p>
                                <button
                                    className="probiotique_intro_probio-btn"
                                    onClick={() => scrollToSection(probiotiqueSectionRef)}
                                >
                                    VPRO® Probiotics
                                </button>
                                <button
                                    className="probiotique_intro_postbio-btn"
                                    onClick={() => scrollToSection(postbiotiqueSectionRef)}
                                >
                                    PROLIPO® Postbiotics
                                </button>
                            </div>
                            <img className="probiotique_intro-img" src={intro_img} alt="Probiotique" />
                        </section>
                    )}
                <section ref={probiotiqueSectionRef} className="probiotique_positifPoint-container-bg">
                    <div className="probiotique_positifPoint-container">
                        <div className="probiotique_positifPoint_content-container">
                            <h2 className="probiotique_positifPoint-title"><label className="orange-color"> probiotics :</label><br />intestinal balance<br />at its source</h2>
                            <p className="probiotique_positifPoint-text">Probiotics are living micro-organisms that provide specific health benefits when administered in the right quantities. At LIN, we provide strains recognised for their efficiency, such as Lactobacillus acidophilus, Bifidobacterium longum, Lactobacillus rhamnosus, and many others.
                                <br /><br />
                                Thanks to our expertise in probiotics, we can help you develop products adapted to current trends and consumer expectations.
                            </p>
                        </div>
                        <div className="probiotique_positifPoint-positifPoint">
                            {probioPositifPoint.map(([title, content], index) => (
                                <PositifPoint key={index} title={title} content={content} />
                            ))}
                        </div>
                    </div>
                </section>
                <section className="probiotique_tech-container">
                    <h2 className="probiotique_tech-title"><label className="orange-color">VPRO® technology,  </label><br />a revolutionary advance</h2>
                    <div className="probiotique_tech_content-container">
                        <p className="probiotique_tech-text">
                            VPRO® technology optimises the stability and efficiency of probiotics. Thanks to the microencapsulation of probiotics, the activity and survival of the strains are optimised during storage and absorption in the stomach.
                            <br /><br />                       
                            This innovative process provides enhanced protection against gastric acidity and humidity to ensure optimal colonisation of the intestine for long-lasting action. 
                            <br /><br />
                            VPRO® ensures targeted release and optimal bioavailability, meeting the highest standards of intestinal health and well-being.
                        </p>
                        <img className="probiotique_tech-img" src={probio} />
                        <div className="probiotique_tech_checkList-container">
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">Resistant to gastric acid, bile and storage  </p>
                            </div>
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">Excellent survival rate of strains in the gastrointestinal tract</p>
                            </div>
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">High viability until the end of the storage period, excellent stability</p>
                            </div>
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">High adhesion capacity, high colonisation, targeted release in the intestine</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="probiotique_listingMp-container">
                    <TabCatalogue produits={produits} type="probiotique" />
                    <MoreInfo
                        label={"Contact us"}
                        link={"*"}
                    />
                </section>
                <section ref={postbiotiqueSectionRef} id="postbiotique_positifPoint-container-bg" className="postbiotique_positifPoint-container-bg">
                    <div className="probiotique_positifPoint-container">
                        <div className="probiotique_positifPoint_content-container">
                            <h2 className="probiotique_positifPoint-title"><label className="orange-color"> postbiotics :</label><br />innovation for health</h2>
                            <p className="probiotique_positifPoint-text">
                                Postbiotics are bioactive compounds produced by probiotics during fermentation. Unlike living probiotics, postbiotics do not need to be alive to be efficient, offering unique benefits.
                                <br /><br />
                                By incorporating postbiotics into your formulations, you benefit from a stable and effective alternative to probiotics, ideal for a new generation of food supplements.
                            </p>
                        </div>
                        <div className="probiotique_positifPoint-positifPoint">
                            {postbioPositifPoint.map(([title, content], index) => (
                                <PositifPoint key={index} title={title} content={content} />
                            ))}
                        </div>
                    </div>
                </section>
                <section className="postbiotique_tech-container">
                    <h2 className="probiotique_tech-title"><label className="orange-color">PROLIPO® technology</label><br />For your Postbiotics</h2>
                    <div className="probiotique_tech_content-container">
                        <p className="probiotique_tech-text">
                            Thanks to advanced encapsulation of posbiotics, PROLIPO® provides optimum protection for postbiotics, enhancing their stability and bioavailability. 
                            <br /><br />
                            This innovative process improves the targeted release of active ingredients into the body, guaranteeing effective assimilation and long-lasting action.
                        </p>
                        <img className="probiotique_tech-img" src={postbio} />
                        <div className="probiotique_tech_checkList-container">
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">Optimum protection of postbiotics against external aggression </p>
                            </div>
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">Improved bioavailability for enhanced efficiency</p>
                            </div>
                            <div className="probiotique_tech_checkList-item">
                                <div className="probiotique_tech_checkList-icon-container">
                                    <p className="probiotique_tech_checkList-icon">✔</p>
                                </div>
                                <p className="probiotique_tech_checkList-text">Targeted release in the body for prolonged action</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="postbiotique_listingMp-container">
                    <TabPostbiotique />
                </section>
                <MoreInfo label={"Contact us"} link={"*"} />
                <section className="probiotique_choice_global-container">
                    <h3 className="liposome_choice-title">Why choose our <label className="orange-color"> MICROENCAPSULATED <br />active ingredients ?</label></h3>
                    <p className="liposome_choice-text">Choosing our microencapsulated active ingredients means opting for high-performance ingredients and an advanced technology that significantly improves their efficiency. Our formulations are tailored to the needs of the dietary supplements market and offer impeccable quality, thanks to in-depth expertise and strict controls.</p>
                    <div className="liposome_choice-2bloc-container">
                        <div className="liposome_choice-leftBloc-container">
                            <h4 className="liposome_choice-leftBloc-title"><label className="orange-color">flexible</label> tailor-made production</h4>
                            <p className="liposome_choice-leftBloc-text">
                                We offer a flexible manufacturing solution, from small batches to large-scale production, to meet the specific needs of each brand.  
                                <br /><br />
                                Whether white label or custom development, our expertise guarantees optimum quality and efficacy for your liposome products.
                            </p>
                            <img className="liposome_choice-leftBloc-img" src={left_schema} />
                        </div>
                        <div className="liposome_choice-rightBloc-contaienr">
                            <h4 className="liposome_choice-rightBloc-title">Commitment to quality and  <br />
                                recognised certifications
                            </h4>
                            <p className="liposome_choice-rightBloc-text">Our standards guarantee complete traceability, from the selection of raw materials to the final product. 
                                <br /><br />
                                Our liposomal food supplements have international certifications attesting our commitment to quality (HACCP, GMP Food, Synadiet).
                            </p>
                            <img className="liposome_choice-rightBloc-img" src={right_schema} />
                        </div>
                    </div>
                    <div className="liposome_choice_bottomBloc-container">
                        <div className="liposome_choice_bottomBloc-description-container">
                            <h4 className="liposome_choice_bottomBloc-description-title">Full assistance <label className="orange-color">from <br /> formulation to market launch</label></h4>
                            <p className="liposome_choice_bottomBloc-description-text">Our laboratory is not limited to production: we support our customers at  every stage of their project, from the initial formulation right through to market launch.
                                <br /><br />
                                Our service also includes regulatory monitoring and packaging assistance, ensuring that your food supplements are both compliant and appealing for fast and effective launch on the market.
                            </p>
                        </div>
                        <img className="liposome_choice_bottomBloc-description-img" src={bottom_schema} />
                    </div>
                </section>
                <section className='formule_otherProduct_global-container'>
                    <h3 className='formule_otherCategory-title'>
                        <label className='bold'>Nos autres</label>
                        <label className='orange-color'> catégories d'ingrédients</label>
                    </h3>
                    <OtherProduct
                        title1={"niosomes"}
                        subtitle1={"Cosmetics"}
                        img1={niosome}
                        link1={"/niosomes"}
                        title2={"Liposomes"}
                        subtitle2={"Plant extracts Vitamins · Minerals"}
                        img2={liposome}
                        link2={"/liposomes"}
                    />
                </section>
            </div>
        </div>
    );
}
